var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41079 6.57742C9.73622 6.25198 10.2639 6.25198 10.5893 6.57742L16.4226 12.4108C16.7481 12.7362 16.7481 13.2638 16.4226 13.5893C16.0972 13.9147 15.5696 13.9147 15.2441 13.5893L10 8.34519L4.75596 13.5893C4.43053 13.9147 3.90289 13.9147 3.57745 13.5893C3.25201 13.2638 3.25201 12.7362 3.57745 12.4108L9.41079 6.57742Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpGray);
export default __webpack_public_path__ + "static/media/up_gray.672f696f5845b9f43eb59a45ebfbd4c9.svg";
export { ForwardRef as ReactComponent };